// Libraries
import React, { useEffect, useState } from 'react';
import { Routes, Route, Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { Box, Flex, FlexItem, ProgressCircle, ProgressBar } from '@bigcommerce/big-design';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import firebase from './utils/fb-config';

// Styles
import './styles/styles.scss';

// Components
import AppContext from './components/AppContext';
import Header from './components/Header';
import MainView from './components/MainView';
import Events from './components/views/Events/Events';
import EditEvent from './components/views/Events/Edit';
import EventAttendees from './components/views/Events/Attendees';

// Extensions

function App() {

    const location = useLocation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [userToken, setUserToken] = useState('');
    const [storeHash, setStoreHash] = useState('');
    const globalProps = {
        user_token: userToken,
        store_hash: storeHash,
    };
    // Header Tabs
    const [activeTab, setActiveTab] = useState('store-locator');

    // Authenticate user with BC signed_payload
    useEffect(() => {
        async function authenticateUser() {
      console.log("Initiating Auth")
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('signed_payload')) {
        const signed_payload = urlParams.get('signed_payload')
        try {
          console.log('Login into Firebase')
          const verifyRes = await fetch(`${process.env.REACT_APP_API_URL}/app/verify?signed_payload=${signed_payload}`)
          const verifyData = await verifyRes.json()
          console.log('Logged In', verifyData)
          if (verifyData.user && verifyData.user.id) {
            setUserToken(signed_payload);
            setStoreHash(verifyData.store_hash);
            setIsAuthenticated(true) 
            setIsLoading(false);
          }
        } catch(err) {
          console.log('Login unsuccessful')
        }
      } else {       
        console.log('Token not found')
      }
    }

    authenticateUser()
    }, []);

    const ProtectedRoute = ({
        isAllowed,
        redirectPath = '/login',
        children,
    }) => {
        if (!isAllowed) {
            return <Navigate to={redirectPath} replace />;
        }
        
        return children;
    };

    return (
        <Box className='app-wrapper'>
            <Routes>
                <Route element={<Loading isLoading={isLoading} path={location.pathname} />}>
                    <Route element={<DashBoard activeTab={activeTab} globalProps={globalProps} setActiveTab={setActiveTab} isLoading={isLoading} />}>
                        <Route path="/" element={
                            <ProtectedRoute isAllowed={isAuthenticated} >
                                <Events />
                            </ProtectedRoute>
                        }/>
                        <Route path="/events" element={
                            <ProtectedRoute isAllowed={isAuthenticated} >
                                <Events />
                            </ProtectedRoute>
                        }/>
                        <Route path="/events/:id" element={
                            <ProtectedRoute isAllowed={isAuthenticated} >
                                <EditEvent />
                            </ProtectedRoute>
                        }/>
                        <Route path="/events/:id/attendees" element={
                            <ProtectedRoute isAllowed={isAuthenticated} >
                                <EventAttendees />
                            </ProtectedRoute>
                        }/>
                    </Route>
                    <Route path="login" element={<Login />} />
                </Route>
            </Routes>
        </Box>
    );
}

function Login() {
    return (
        <Box>
            <h1>This app can only be accessed through the BC control Panel</h1>
        </Box>
    );
}

function Loading ({ isLoading, path }) {
    const LoadingBar = () => {
        if (path.includes('extensions')) {
            return (
                <div className={"loading-bar"}>
                    <ProgressBar />
                </div>
            );
        }
        return (
            <div className={"loading-circle"}>
                <ProgressCircle size="large" />
            </div>
        );
    };


    return (
        <>
            {isLoading ?
                <LoadingBar /> :
                <Outlet />
            }
        </>
    );
}

function DashBoard({ activeTab, globalProps, setActiveTab, isLoading}) {
    return (
        <Flex className="app" flexDirection="column">
            <Header
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
            <FlexItem
                as="main"
                id="main"
                backgroundColor="secondary10"
                flexGrow={1}
            >
                <AppContext.Provider value={globalProps}>
                    <Outlet />
                </AppContext.Provider>
            </FlexItem>
        </Flex>
    );
}

export default App;
